import ApiStepBaseView from './base';
import app from '../../../app/app';
import templateWebpack from '../../../../tpl/item/api-step/adult.hbs';
import * as Constants from '../../../config/constants';
import {getIntl} from '../../../intl';


export default class AdultApiStep extends ApiStepBaseView {
    constructor (options = {}) {
        super({
            templateWebpack,
            showValidationSuccess: true,
            ...options
        });
        this.listenTo(this.model.inputs, 'change:inputValue', this.onChangeTracking);
    }


    /**
     * View regions.
     * Any region defined under the key of an input id will be filled with the
     * corresponding input view when calling the 'renderApiInputsToRegions' method..
     */
    regions () {
        return {
            [Constants.NETMATCH_INPUT_ADULT_SALUTATIONCODE]: {
                el: '.api-input-salutationcode',
                replaceElement: true
            },
            [Constants.NETMATCH_INPUT_ADULT_TITLE]: {
                el: '.api-input-title',
                replaceElement: true
            },
            [Constants.NETMATCH_INPUT_ADULT_FIRSTNAME]: {
                el: '.api-input-firstname',
                replaceElement: true
            },
            [Constants.NETMATCH_INPUT_ADULT_LASTNAME]: {
                el: '.api-input-lastname',
                replaceElement: true
            },
            [Constants.NETMATCH_INPUT_ADULT_DATEOFBIRTH]: {
                el: '.api-input-dayofbirth',
                replaceElement: true
            },
            [Constants.NETMATCH_INPUT_ADULT_NATIONALITY]: {
                el: '.api-input-nationality',
                replaceElement: true
            }
        };
    }


    /**
     * Any object defined under the key of an input id will be passed as options
     * into the input views created when calling the 'renderApiInputsToRegions' method.
     */
    apiInputViewOptions () {
        const {formatMessage} = getIntl();
        const showValidationSuccess = !!this.getOption('showValidationSuccess');
        const adultID = this.model.get('adultIndex');

        return {
            [Constants.NETMATCH_INPUT_ADULT_SALUTATIONCODE]: {
                showValidationSuccess,
                displayType: 'radiobuttons',
                additionalTemplateContext: {
                    // darkStyling: true,
                    label: ' ',
                    nothingSubmittedOption: formatMessage({
                        id: 'tpl.item.api-step.view.adult.salutation'
                    })
                }
            },
            [Constants.NETMATCH_INPUT_ADULT_TITLE]: {
                showValidationSuccess,
                additionalTemplateContext: {
                    label: ' ',
                    nothingSubmittedOption: formatMessage({
                        id: 'tpl.item.api-step.view.adult.title'
                    }),
                    resetDummyOption: formatMessage({
                        id: 'tpl.item.api-step.view.adult.title'
                    })
                }
            },
            [Constants.NETMATCH_INPUT_ADULT_FIRSTNAME]: {
                showValidationSuccess,
                additionalTemplateContext: {
                    label: formatMessage({
                        id: 'tpl.item.api-step.view.adult.firstname'
                    }),
                    autocomplete: `section-adult.${adultID} shipping given-name`, // autocomplete: 'on',
                    name: 'fname',
                    maxlength: 34
                }
            },
            [Constants.NETMATCH_INPUT_ADULT_LASTNAME]: {
                showValidationSuccess,
                additionalTemplateContext: {
                    label: formatMessage({
                        id: 'tpl.item.api-step.view.adult.lastname'
                    }),
                    autocomplete: `section-adult.${adultID} shipping family-name`, // autocomplete: 'on',
                    name: 'lname',
                    maxlength: 34
                }
            },
            [Constants.NETMATCH_INPUT_ADULT_DATEOFBIRTH]: {
                displayType: 'date',
                showValidationSuccess,
                additionalTemplateContext: {
                    label: formatMessage({
                        id: 'tpl.item.api-step.view.adult.dateofbirth'
                    }),
                    placeholderValue: formatMessage({
                        id: 'tpl.item.api-step.view.adult.dateofbirth-placeholder'
                    }),
                    autocomplete: 'on',
                    maxlength: 10,
                    name: 'bday'
                }
            },
            [Constants.NETMATCH_INPUT_ADULT_NATIONALITY]: {
                showValidationSuccess,
                displayType: 'select',
                additionalTemplateContext: {
                    nothingSubmittedOption: getIntl().formatMessage({
                        id: 'tpl.item.api-step.view.adult.nationality'
                    }),
                    resetDummyOption: getIntl().formatMessage({
                        id: 'tpl.item.api-step.view.adult.nationality'
                    }),
                    autocomplete: `section-adult.${adultID} shipping country`,
                    name: 'country'
                }
            }
        };
    }

    onRender () {
        this.renderApiInputsToRegions(this.model.inputs);
    }

    onChangeTracking (inputModelChange) {
        const isAdult = inputModelChange.collection.parentModel.get('adultIndex');
        const translate = {
            [Constants.NETMATCH_INPUT_ADULT_SALUTATIONCODE]: 'Anrede',
            [Constants.NETMATCH_INPUT_ADULT_TITLE]: 'Titel',
            [Constants.NETMATCH_INPUT_ADULT_FIRSTNAME]: 'Vorname(n)',
            [Constants.NETMATCH_INPUT_ADULT_LASTNAME]: 'Nachname',
            [Constants.NETMATCH_INPUT_ADULT_DATEOFBIRTH]: 'Geburtsdatum',
            [Constants.NETMATCH_INPUT_ADULT_NATIONALITY]: 'Nationalität'
        };
        let participant = '';
        let forGA4participant = '';
        if (isAdult) {
            participant = `|Erwachsener|${isAdult}`;
            forGA4participant = `-Erwachsener-${isAdult}`;
        }

        // console.log(inputModelChange.changed, inputModelChange.id, inputModelChange.collection.parentModel.id);
        if (translate[inputModelChange.id]) {
            app.trackController.eventTracking({
                action: 'Daten',
                label: `${translate[inputModelChange.id]}${participant}`,
                ga4clickLabel: `content.custom.daten-${translate[inputModelChange.id]}${forGA4participant}`
            });
        }
        if (inputModelChange.hasInputError() && inputModelChange.getInputError()) {
            const label = inputModelChange.get('label');
            app.trackController.eventTracking({
                ga4eventName: 'form-error',
                ga4formName: `ibe.persoenliche-daten-${label}-Erwachsener-${isAdult}`,
                ga4errorDisplayedMessage: inputModelChange.getInputError()
            });
        }
    }
}
